import CustomHtml from "../../../../components/CustomHtml/component";

/**
 * This function handles creating the proper component structure for a custom HTML widget
 *
 * @param {Object} params the widget params
 *
 * Key properties of the @param params object
 * @param {string} params.id the id to use for a key
 * @param {string} params.htmlContent the html content to display
 *
 * @returns {JSX} component structure for custom HTML widget
 */

const CustomHtmlContainer = ({ params }) => {
    if (!params || !params.htmlContent) {
        return null;
    }

    return (
        <CustomHtml
            html={params.htmlContent}
            targetParent={true}
            name={params.name}
        />
    );
};

export default CustomHtmlContainer;
